import NavigationToParentContainer from './containers/NavigationToParentContainer';

export default NavigationToParentContainer;
